import type { WidgetType } from '@inbx/shared/schemas';

import { CHAT_TEMPLATES } from './chat';
import { FORM_TEMPLATES } from './form';
import { PROMO_TEMPLATES } from './promo';
import { SURVEY_TEMPLATES } from './survey';
import type { WidgetTemplate } from './types';

export const TEMPLATES: WidgetTemplate[] = [
  ...CHAT_TEMPLATES,
  ...FORM_TEMPLATES,
  ...SURVEY_TEMPLATES,
  ...PROMO_TEMPLATES,
];

const BY_ID = new Map(TEMPLATES.map((t) => [t.id, t]));
const DEFAULT_BY_TYPE: Record<WidgetType, string> = {
  chat: 'chat-support',
  form: 'form-card',
  survey: 'survey-card',
  promo: 'promo-modal',
};

/** Шаблон по id; если не найден — дефолтный для типа. */
export function getTemplate(id: string, type: WidgetType): WidgetTemplate | null {
  return BY_ID.get(id) ?? BY_ID.get(DEFAULT_BY_TYPE[type]) ?? null;
}

export type { WidgetTemplate } from './types';
